import { useFeatureFlagEnabled } from "posthog-js/react";

import { NEW_BANKING_ACCOUNTS_PAGE_FLAG } from "../../components/constants";

import { BankingAccountsPage } from "./banking-accounts";
import { BankingNextPage } from "./banking-next";

export const BankingPage = () => {
  const newAccountsPageEnabled = useFeatureFlagEnabled(NEW_BANKING_ACCOUNTS_PAGE_FLAG);
  return newAccountsPageEnabled ? <BankingAccountsPage /> : <BankingNextPage />;
};
